import { Component, Vue } from 'vue-property-decorator';
import { gsap } from 'gsap';

@Component({})
export default class ModalWrapperAnimations extends Vue {
  private timeline: gsap.core.Timeline = gsap.timeline();

  modalEnter(element: HTMLElement, done: () => void) {
    const backdropEl = element.querySelector('.modal__backdrop');
    const windowEl = element.querySelector('.modal__window');

    this.timeline
      .fromTo(backdropEl, { opacity: 0 }, { opacity: 1, duration: 0.5 })
      .fromTo(windowEl, { opacity: 0 }, { opacity: 1, duration: 0.5, onComplete: done }, '-=0.25');
  }

  modalLeave(element: HTMLElement, done: () => void) {
    const backdropEl = element.querySelector('.modal__backdrop');
    const windowEl = element.querySelector('.modal__window');

    this.timeline
      .fromTo(windowEl, { opacity: 1 }, { opacity: 0, duration: 0.5 })
      .fromTo(backdropEl, { opacity: 1 }, { opacity: 0, duration: 0.5, onComplete: done }, '-=0.25');
  }
}
